/* unplugin-vue-components disabled */import script from "./FunctionIntroduction.vue?vue&type=script&setup=true&lang=js"
export * from "./FunctionIntroduction.vue?vue&type=script&setup=true&lang=js"

import "./FunctionIntroduction.vue?vue&type=style&index=0&id=0655492a&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0655492a"]])

export default __exports__